export default __webpack_public_path__ + "static/media/services.5a837583.png";